import { Box } from '@material-ui/core'
import Head from 'next/head'
import React, { useEffect } from 'react'

import { useAnalytics } from '../../lib/analytics'
import useIsMounted from '../../lib/hooks/useIsMounted'
import Footer from '../footer/FooterProvider'
import Header from '../header/HeaderProvider'

const BasePageLayout = ({ title, children }: { children: React.ReactNode; title: string }) => {
  const { trackPage } = useAnalytics()

  const isMounted = useIsMounted()
  useEffect(() => {
    if (isMounted) {
      trackPage()
    }
  }, [isMounted, trackPage])

  return (
    <>
      <Head>
        <title>{title}</title>
      </Head>
      <Box display="flex" flexDirection="column" minHeight="100vh">
        <Box flexShrink={0}>
          <Header />
        </Box>
        <Box display="flex" flex="1 0 auto" flexDirection="column">
          {children}
        </Box>
        <Box flexShrink={0}>
          <Footer />
        </Box>
      </Box>
    </>
  )
}

export default BasePageLayout
